import { createI18n } from "vue-i18n";
import es from "@/locales/es.json";
import en from "@/locales/en.json";
import { APP_CONFIG } from "@/config/app-config";

const messages = {
  es,
  en,
};

const defaultLocale = APP_CONFIG.locale in messages ? APP_CONFIG.locale : "es";

const i18n = createI18n({
    legacy: false, // Compasition API
    locale: defaultLocale,
    fallbackLocale: "es",
    messages,
});

export default i18n;
